<template>
  <div id="app">
    <common-nav :options="options" @showLoginDialog="showLoginDialog" @closeDialog="closeDialog" @loginOut="loginOut" @accountCancel="accountCancel"></common-nav>
    <router-view v-if="isRouterAlive" />
    <div id="payDiv"></div>
    <common-footer
      :options="options"
      class="animate__animated animate__fadeInUp animate__delay-02s"
    ></common-footer>
    <loading :options="options"></loading>
    <common-mask :options="options" @closeDialog="closeDialog"></common-mask>
    <login-modal :options="options"
                 :platFormType="platFormType"
                 @closeDialog="closeDialog" @thirdLoginDialog="thirdLoginDialog"></login-modal>
    <account-cancel
      v-if="showAccountCancel"
      :show_account_cancel="showAccountCancel"
      @closeDialog="closeDialog"
    />
    <FbDialog :isFbDialog="isFbDialog"
              :gamesList="gamesList"
              :platFormType="platFormType"
              @closeFbDialog="closeDialog"></FbDialog>
  </div>
</template>

<script>
import CommonFooter from "@/pc/components/common/CommonFooter.vue";
import CommonMask from "@/pc/components/common/CommonMask.vue";
import CommonNav from "@/pc/components/common/CommonNav.vue";
import LoginModal from "@/pc/components/common/LoginModal.vue";
import AccountCancel from "@/pc/components/memberCenter/AccountCancel.vue";
import FbDialog from "@/pc/components/memberCenter/FbDialog.vue";
import Loading from './components/common/Loading';
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload,
    }
  },
  components: {
    FbDialog,
    AccountCancel,
    CommonMask,
    LoginModal,
    CommonNav,
    CommonFooter,
    Loading,
  },
  data: function () {
    return {
      isRouterAlive: true,
      options: {
        isLogin: false,
        isSign: false,
        isMask: false,
        isLoading: false,
        isIntegralNotes: false,
        isFootani: false,
        isLoginin: false,
        isLoginSuccess: false, //未登入狀態
        isGameani: true,
        isnswiper: false,
        isnlist: false,
        isHmsLogin: true,
        isLoginDialog: false,
      },
      isFbDialog: false,
      showAccountCancel: false,
      signInfoList: {},
      footerInfoList: [],
      signDateList: [],
      gamesList: [],
      firstGameId: 0,
      firstAppId: 0,
      platFormType: '',
      account: '',
      name: '',
      token: '',
      type: '',
      signature: '',

    }
  },
  created() {
    if (localStorage.getItem('token') && localStorage.getItem('userInfo')) {
      this.$store.commit('setToken', localStorage.getItem('token'))
      this.$store.commit(
        'setUserInfo',
        JSON.parse(localStorage.getItem('userInfo'))
      )
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.thirdLogin();
    this.getHomeGamesList();
    if (localStorage.getItem('token')) {
      this.options.isLoginin = true
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    showLoginDialog: function () {
      this.options.isMask = true
      this.options.isLoginDialog = true
    },
    closeDialog: function () {
      this.options.isLogin = false
      this.options.isSign = false
      this.options.isMask = false
      this.options.isIntegralNotes = false
      this.isFbDialog = false
      this.options.isLoginDialog = false;
      this.showAccountCancel = false
      //同时关闭nav下拉列表
    },
    handleLogin: function () {
      this.options.isLogin = false
      this.options.isSign = true
    },
    handleScroll: function () {
      var st = document.documentElement.scrollTop
      if (st >= 2500) {
        this.options.isFootani = true
      }
    },
    morefunLogin: function (userName, passWord) {
      this.options.isLoading = true
      let datas = {
        account: userName,
        password: passWord,
      }
      this.postHttp(this, datas, '/front/login', function (obj, data) {
        if (data) {
          if (data.status === 2000) {
            obj.options.isLoading = false
            obj.$toast('登入成功!')
            obj.options.isLogin = false
            obj.options.isLoginin = true
            obj.options.isLoginSuccess = true
            let token = data.data.bear_token
            let userInfo = data.data.user_info
            obj.$store.commit('setToken', token)
            obj.$store.commit('setUserInfo', userInfo)
            localStorage.setItem('token', token)
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            obj.reload()
            obj.options.isLoading = true
            obj.options.isMask = true
            obj.options.isSign = true
            obj.options.isLoading = false
          } else {
            obj.options.isLoading = false
            obj.options.isLogin = false
            obj.options.isSign = false
            obj.options.isMask = false
            obj.$toast(data.message)
          }
        } else {
          obj.options.isLoading = false
          obj.options.isSign = false
          obj.options.isMask = false
          obj.options.isLogin = false
          obj.$toast('網絡錯誤，請稍候重試!')
        }
      })
    },
    thirdLoginDialog: function (type) {
      this.isFbDialog = true;
      this.getAllGamesList();
      this.platFormType = type;
      this.options.isMask = true;
      this.options.isLoginDialog = false;
    },
    thirdLogin: function () {
      // 三方登录接口
      this.options.isLoading = true;
      this.account = this.$utils.getUrlKey("account");
      this.name = this.$utils.getUrlKey("name");
      this.token = this.$utils.getUrlKey("token");
      this.type = this.$utils.getUrlKey("type");
      this.signature = this.$utils.getUrlKey("signature");
      if (this.account && this.name && this.token && this.type) {
        let datas = {
          account: this.account,
          name: this.name,
          token: this.token,
          type: this.type,
        };
        this.postHttp(this, datas, "/front/others/login", function (obj, data) {
          if (data.status === 2000) {
            obj.options.isLoading = false;
            obj.options.isMask = false;

            let token = data.data.bear_token;
            let userInfo = data.data.user_info;
            obj.$store.commit("setToken", token);
            obj.$store.commit("setUserInfo", userInfo);
            localStorage.setItem("token", token);
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
            obj.options.isHmsLogin = false;
            obj.$store.commit("setIsHmsLogin", false);
          } else {
            obj.options.isLoading = false;
          }
          obj.$toast(data.message);
        });
      } else {
        this.options.isLoading = false;
      }
    },
    getAllGamesList: function () {
      this.getHttp(this, "", "/front/game/all", function (obj, data) {
        if (data.status === 2000) {
          obj.gamesList = data.data;
          obj.firstGameId = data.data[0].id;
        }
      });
    },
    getHomeGamesList: function () {
      this.getHttp(this, "", "/front/home/games", function (obj, data) {
        if (data.status === 2000) {
          obj.homeGamesList = data.data;
        } else {
          obj.$toast(data.message);
        }
      });
    },
    closeLoginModel: function () {
      this.options.isLoginDialog = false;
      this.options.isMask = false;
    },
    loginOut: function () {
      this.options.isLoading = false;
      this.$store.commit("setIsHmsLogin", true);
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      this.$store.commit("setToken", "");
      this.$store.commit("setUserInfo", {});
      this.$toast("已登出");
      this.$router.push({ path: "/home" });
      this.$store.commit("loginOut");
    },
    // 注销账户
    accountCancel:function (){
      let token = localStorage.getItem("token");
      if (!token) {
        this.$toast("請先登錄帳號");
      } else {
        this.showAccountCancel = true;
      }
    },
  },
}
</script>

<style lang="stylus">
#app {
  font-family: Arial, '微软雅黑', 'Microsoft YaHei';
  overflow-x: auto;
}
</style>
